<template>
  <div class="pt-50">
    <h1 class="mb-50 text-left text-purpink text-capitalize text-warning">
      {{ "Create your project now" | __t("projects__wizard__headline__create-your-project-now") }}
    </h1>

    <b-alert v-if="errorCode" show variant="danger" class="rounded-lg">
      <p class="mb-0">{{ "An error happened." | __t("message__an-error-happened") }} ({{ errorCode }})</p>
    </b-alert>

    <div class="p-3 bg-light rounded">
      <form-builder
        :state-machine="stateMachine"
        :components-list="componentsList"
        :custom-validators="{}"
        :is-sending="isSending"
        @submit="nextStep"
        class="wizard-project"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { CREATE } from "@/store/actions";

import { FormBuilder } from "ui-stepper";
import { BAlert } from "bootstrap-vue";

import { WIZARD_STATE_MACHINE } from "@/constants/project";

import { stateMachineTranslater } from "@/helpers/uiStepper";

export default {
  name: "ProjectWizard",
  components: {
    BAlert,
    FormBuilder,
  },
  computed: {
    wizard() {
      return this.$route.query.wizard;
    },

    isMobile() {
      const { value } = this.$screen.alias;
      return value === "xs" || value === "sm" || value === "md";
    },
  },
  data: () => ({
    name: null,

    stateMachine: stateMachineTranslater(WIZARD_STATE_MACHINE),
    componentsList: {},

    errorCode: null,

    isSending: false,
  }),
  methods: {
    ...mapActions("projects", { createProject: CREATE }),
    async triggerCeateProject() {
      this.errorCode = null;
      this.isSending = true;

      const { name } = this;
      console.log("name", name);
      const { isSuccess, projectId, errorCode } = await this.createProject({ name });

      if (isSuccess && projectId) {
        this.$router.push({ name: "Project", params: { projectId }, query: { createTask: true } });
        return;
      }

      this.errorCode = errorCode;
      this.isSending = false;
    },

    nextStep() {
      const { name } = this.stateMachine.context.formData;

      this.name = name;
      this.triggerCeateProject();
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_settings";

.wizard-project .field-name {
  font-weight: bold;
  font-family: "Poppins";
}

.wizard-project .btn {
  background-color: $warning !important;
  border-radius: 0.25rem !important;
  border: 0px !important;
  font-weight: semibold !important;
  font-family: "Poppins" !important;
  color: white !important;
  width: 100% !important;
}
</style>
